import React from 'react';
import styled from 'styled-components';
import { Container } from '../../../view/Containers';
import { HighlightedPLight, Paragraph } from '../../../view/Paragraph';
import { HorizontalCardFullPage, HorizontalCardInnerFullPage } from '../../../view/HorizontalCard';
import { HeaderWithSeparator } from '../../../view/TextSubHeaders';
import { Box } from '../../../view/Boxes';
import { Margin } from '../../../view/Margin';
import { BorderSquareSection } from '../../../view/Sections/BorderSquareSection';
import aboutUsMission from '../../../img/AboutUs/aboutUsMission.png';
import history from '../../../img/AboutUs/history.jpg';
import quality from '../../../img/AboutUs/quality.jpg';
import technology from '../../../img/AboutUs/technology.jpg';
import tradition from '../../../img/AboutUs/tradition.jpg';

// BOXES
import box1 from '../../../img/AboutUs/box1.jpg';
import box2 from '../../../img/AboutUs/box2.jpg';
import box3 from '../../../img/AboutUs/box3.jpg';
import box4 from '../../../img/AboutUs/box4.jpg';
import box5 from '../../../img/AboutUs/box5.jpg';
import box6 from '../../../img/AboutUs/box6.jpg';

const ImagesBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
`;

const AboutUsBoxesImgs = [box1, box2, box3, box4, box5, box6];
const ContainerImages = styled(Container)`
  @media screen and (max-width: 1200px) {
    display: none;
  }
`;

export const AboutUsSectionBody = (): JSX.Element => (
  <>
    <Container padding inColor>
      <article>
        <HighlightedPLight as="h2">
          Dzień dobry. Nazywam się Paulina Chruślińska.
          Ogrodnictwem i rolnictwem zajmuję się jak to się zwykło mawiać z dziada pradziada.
        </HighlightedPLight>
        <Paragraph>
          Moją pasją jest uprawa owoców i warzyw oraz ich przetwarzanie na soki,
          syropy, dżemy, kiszonki i inne domowe przetwory.
          Odkąd tylko pamiętam,  zawsze w moim rodzinnym domu były również swojskie wędliny i sery.
          Jako dziecko pomagałam rodzicom w ich przygotowywaniu.
          Teraz jako dorosła osoba, kultywuję taki
          sposób odżywiania. Odkąd zostałam mamą dwóch chłopców  jeszcze bardziej
          zaczęłam zwracać uwagę na to co kładę na stole,
          dzięki czemu moja rodzina cieszy się naturalnym i
          smacznym jedzeniem oraz przede wszystkim zdrowiem.
        </Paragraph>
        <Paragraph>
          Swoimi wyrobami dzielę się także z przyjaciółmi i znajomymi.
          Stąd też powiększana z roku na rok produkcja naturalnego jedzenia sprawiła,
          że powstało “Owocowo”, a przetwory zaczęliśmy tworzyć w większych
          ilościach także dla innych i Ciebie.
        </Paragraph>
      </article>
    </Container>
    <Container>
      <HorizontalCardFullPage url={aboutUsMission}>
        <HorizontalCardInnerFullPage>
          <div>
            <HeaderWithSeparator as="h2" header="Misja" upperSubHeader="nasza" />
            <Paragraph>
              Naszą misją, misją gospodarstwa Owocowo jest dostarczanie Ci całej gamy zdrowych,
              w pełni naturalnych i swojskich wyrobów spożywczy wolnych
              od pestycydów i niepotrzebnej chemii.
              Wszystko po to abyś nie musiał kupować sztucznego jedzenia w
              supermarketach i mógł cieszyć się zdrowiem.
              Zobacz na czym polega nasza metoda OWOCOWO
            </Paragraph>
          </div>
        </HorizontalCardInnerFullPage>
      </HorizontalCardFullPage>
    </Container>
    <Container padding>
      <article>
        <Paragraph>
          Owoce i warzywa oraz zioła, których używamy do naszych przetworów pochodzą
          z naszego gospodarstwa (z drobnymi wyjatkami, ale wtedy zawsze zaopatrujemy się w
          zaprzyjaźnionych certyfikowanych ogrodach),
          gdzie plantacje i uprawy prowadzimy w sposób ekologiczny
          i w pełni naturalny, wolny od sztucznych oprysków i sztucznego nawożenia.
          A nawet z daleka od ruchliwych dróg.
        </Paragraph>
        <Paragraph>
          Dbamy o naturalną jakość jedzenia od samego początku, od ziarna i sadzonki,
          przez naturalny i nieprzyspieszany wzrost roślin i ich owocowanie aż po
          zbiór i produkcję naturalnych przetworów. Tylko taki
          tradycyjny sposób wytwarzania jedzenia,
          gdzie w jednym gospodarstwie uprawia się ekologicznie rośliny i z ich plonów wytwarza się
          przetwory daje Ci 100% pewność, że dostajesz w pełni naturalne jedzenie.
        </Paragraph>
        <Paragraph>
          Nasze prztwory przygotowujemy według tradycyjnych przepisów, nie używamy aromatów i ulepszaczy, ani żadnych konserwantów. Ich skład jest wyjatkowo prosty, a smak zapewniają tradycyjne i domowe metody przygotowania - tak jak u babci.
        </Paragraph>
        <Paragraph>
          Współpracujemy z SGGW, które bada zarówno nasze owoce i warzywa jak i same przetwory pod kątem wartości odżywczych i właściwości ekologicznych.
        </Paragraph>
      </article>
    </Container>
    <ContainerImages>
      <ImagesBox>
        {AboutUsBoxesImgs.map((image, i) => i < 3 && (
          <Box centered img={image} />
        ))}
      </ImagesBox>
      <ImagesBox>
        {AboutUsBoxesImgs.map((image, i) => i > 2 && (
          <Box centered img={image} />
        ))}
      </ImagesBox>
    </ContainerImages>
    <Container>
      <HorizontalCardFullPage side="flex-start" url={quality}>
        <HorizontalCardInnerFullPage>
          <div>
            <HeaderWithSeparator as="h2" header="Jakość" upperSubHeader="potwierdzona" />
            <Paragraph>
              Potwierdzeniem wysokiej jakości naszych przetworów, są nie tylko opinie stałych klientów ale i zadowolenie moich synów: Antosia i Frania. Oni zjadają tylko to co im najbardziej smakuje. A ja daję im tylko to co jest w 100% bezpieczne i sprawdzone.
            </Paragraph>
          </div>
        </HorizontalCardInnerFullPage>
      </HorizontalCardFullPage>
    </Container>
    <Margin height={30} />
    <Container>
      <HorizontalCardFullPage url={tradition}>
        <HorizontalCardInnerFullPage>
          <div>
            <HeaderWithSeparator as="h2" header="Tradycja" upperSubHeader="nasza baza" />
            <Paragraph>
              W gospodarstwie uprawiamy głównie stare odmiany owoców, po to aby przetwory miały jak najbardziej tradycyjny smak. Soki i dżemy produkujemy metoda domową, można by rzec  „garnkową” wg. receptur naszych babć, co sprawia, że możemy zaproponować przetwory cieszące aromatem i smakiem jaki pamiętamy
              z dzieciństwa.
            </Paragraph>
          </div>
        </HorizontalCardInnerFullPage>
      </HorizontalCardFullPage>
    </Container>
    <Margin height={30} />
    <Container>
      <HorizontalCardFullPage side="flex-start" url={technology}>
        <HorizontalCardInnerFullPage>
          <div>
            <HeaderWithSeparator as="h2" header="Nowoczesności" upperSubHeader="za małą dozą" />
            <Paragraph>
              Do zbioru niektórych owoców używamy specjalnego kombajnu, który delikatnie otrząsając krzaki, zbiera tylko najdojrzalsze owoce. Wiele witamin powstaje dopiero w ostatniej fazie dojrzewania. Dlatego zbieramy owoce i warzywa dopiero wtedy, kiedy osiągną pełną dojrzałość co sprawia, że posiadają najwyższe wartości prozdrowotne.
            </Paragraph>
          </div>
        </HorizontalCardInnerFullPage>
      </HorizontalCardFullPage>
    </Container>
    <Container>
      <BorderSquareSection
        subHeader="RYS"
        header="Historyczny"
        img={history}
      >
        Pasję ogrodniczą odziedziczyłam po przodkach ze strony Taty, a sięga ona drugiej połowy XIX wieku. Mój pradziadek, Walenty Budniak był ogrodnikiem u hrabiego Raczyńskiego w Obrzycku w Wielkopolsce. Mój dziadek, Wincenty Budniak ukończył w 1926 roku szkołę ogrodniczą w Kwilczu. W latach 20-tych ubiegłego wieku pracował w Ogrodach Miejskich w Poznaniu. Od 1933 roku prowadził ogród u hrabiego Moszyńskiego w Łoniowie na ziemi sandomierskiej. Po wojnie tj. od 1945 roku był dyrektorem Stacji Nasienno-Szkółkarskiej w Łoniowie. Mój tata – Szymon także jest ogrodnikiem. W latach 80-tych ubiegłego wieku odbył staż naukowy w Stanach Zjednoczonych, gdzie wysłał go prof. Pieniążek z Instytutu Sadownictwa w Skierniewicach.
      </BorderSquareSection>
    </Container>
  </>
);
